import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from "utils/helpers/common/http-methods";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";

export const MINOR_APIs = {
  uploadFile: (body: FormData) => postRequest("/file/upload", body),
  getMinorProfile: () => getRequest(`/user/profile`),
  updateMinor: (minorId: number, body: Partial<MinorDTO>) => patchRequest(`/attendee/minor/${minorId}/profile`, body),
  getMinorHome: () => getRequest(`/attendee/minor/home`),
  getEventsTestingRefactored: (params: any) => getRequest(`/event/get/testing/refactored`, params),
  getEventById: (eventId: number) => getRequest(`/event/${eventId}/details`),
  getAttendeeHome: () => getRequest("/attendee/home"),
  getUserById: (id: number) => getRequest(`users/${id}`),
  getWishlistedMinors: (eventId: number) => getRequest(`event/${eventId}/wishlist`),
  addToWishlist: (eventId: number) => postRequest(`/event/${eventId}/wishlist`, {}),
  removeFromWishlist: (eventId: number) => deleteRequest(`/event/${eventId}/wishlist`),
  getMyBadges: (params: any) => getRequest("/users/my/awarded/badges", params),
  toggleNotification: () => postRequest("/auth/notification-toggle", {}),
};
